/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Contact_HotlineInputs */

const vi_shop_contact_hotline = /** @type {(inputs: Shop_Contact_HotlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hotline`)
};

/**

* @param {Shop_Contact_HotlineInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_contact_hotline = /** @type {((inputs?: Shop_Contact_HotlineInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Contact_HotlineInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_contact_hotline(inputs)
});